import axios from "axios";

const show = npi => axios.get(`/api/v1/provider_manager_dashboards/${npi}`);

const create = payload =>
  axios.post(`/api/v1/provider_manager_dashboards`, {
    provider_manager_dashboard: payload,
  });

const update = (npi_number, payload) =>
  axios.put(`/api/v1/provider_manager_dashboards/${npi_number}`, {
    provider_manager_dashboard: payload,
  });

const search = payload =>
  axios.post(`/api/v1/provider_manager_dashboards/search`, {
    provider_manager_dashboard: payload,
  });

const fetchSpecificEntityItems = entityID =>
  axios.get(
    `/api/v1/provider_manager_dashboards/${entityID}/fetch_specific_entity_items`
  );

const providerManagerDashboardApi = {
  show,
  create,
  update,
  search,
  fetchSpecificEntityItems,
};

export default providerManagerDashboardApi;
